import { createContext } from "react";
import IProjectContext from "../../types/ProjectState";

const defaultState = {
  projects: [],
  selectedProject: null,
  error: null,
  loaded: false,
  loading: false,
};

const ProjectContext = createContext<IProjectContext>(defaultState);

export default ProjectContext;
